import { render, staticRenderFns } from "./DepartmentForm.vue?vue&type=template&id=ce97173a&"
import script from "./DepartmentForm.vue?vue&type=script&lang=js&"
export * from "./DepartmentForm.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentForm.vue?vue&type=style&index=0&id=ce97173a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports